/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 15:25:28
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * createAnnounce
   * @description 创建公告
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  createAnnounce(data) {
    return request.post(`${BASE_URL}/admin_announcement/create`, data)
  },
  /**
   * announceList
   * @description 公告列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  announceList(data) {
    return request.post(`${BASE_URL}/admin_announcement/list`, data)
  },
  /**
   * goBackAnnounce
   * @description 回填数据
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  goBackAnnounce(data) {
    return request.post(`${BASE_URL}/admin_announcement/get_info`, data)
  },
  /**
   * editAnnounce
   * @description 编辑公告
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  editAnnounce(data) {
    return request.post(`${BASE_URL}/admin_announcement/edit`, data)
  },
  /**
   * deleteAnnounce
   * @description 删除公告
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteAnnounce(data) {
    return request.post(`${BASE_URL}/admin_announcement/delete`, data)
  }
}